import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Collapse, Typography } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import moment from 'moment';
import { useLocation } from 'react-router';
import { useHistory } from 'react-router-dom';

import api from 'src/services/api';

import useFetch from 'src/hooks/useFetch';
import { useAlert } from 'src/hooks/useAlert';

import { format_number_to_real } from 'src/utils/format_currency';

import { Container } from 'src/components/Layouts/Container';
import AssinaturaInfo from '../../components/AssinaturaInfo';
import SuperModal from 'src/components/SumperModal';
import { Title } from 'src/components/Layouts/Container/styles';
import { ContratarAssinatura } from '../../components/ContratarAssinatura';
import AssinaturaContratadaModal from './AssinaturaContratadaModal';
import TermoCancelmento from './TermoCancelmento';

import { Button } from '../../components/AssinaturaInfo/styles';
import { instanceAxios } from 'src/InstanceAxios';
import { requestMessageError } from 'src/pages/SignupApp/helpers';

function AssinaturaUsuario() {
  const location = useLocation();
  const history = useHistory();

  const { hasContratarAssinaturaSuccess } = location.state ?? {};

  const usuario = useSelector((state) => state.user);

  const userId = localStorage.getItem('idadmin');

  const { isLoading, data, refetch } = useFetch(
    `buscarAssinaturaUsuario/${usuario?.id}`
  );

  const [formatedAssinatura, setFormatedAssinatura] = useState(null);
  const [modalInfo, setModalInfo] = useState({});
  const [formSubmiting, setFormSubmiting] = useState(false);
  const [showContratarAssinatura, setShowContratarAssinatura] = useState(false);
  const [typeCompany, setTypeCompany] = useState('');
  const [hasCompany, setHasCompany] = useState(false);

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({
    text: '',
    icon: '',
    color: '',
  });

  const { alert, openAlert, closeAlert } = useAlert();

  const modalRef = useRef(null);
  const modalTermoCancelamentoRef = useRef(null);

  // formata assinatura para exibir na tela
  useEffect(() => {
    const company = localStorage.getItem('typeCompany');
    if (company) {
      setTypeCompany(company);
    }
    const hasCompany = localStorage.getItem('hasCompany');
    if (hasCompany === 'true' ? true : false) {
      setHasCompany(hasCompany);
    }

    if (data) {
      const valorAssinatura = format_number_to_real(
        Number.parseFloat(data.PlanoAssinatura.valor) / 100
      );

      const dataVencimento = moment(data.data_vencimento).format('DD/MM/YYYY');
      const dataContratacao = moment(data.createdAt).format('DD/MM/YYYY');

      setFormatedAssinatura({
        status: data.status,
        valorAssinatura,
        dataVencimento,
        dataContratacao,
        idPlanoAssinatura: data?.id_plano_assinatura,
      });
    }
  }, [data]);

  const handleAssinaturaPress = () => {
    if (formatedAssinatura.status === 'Expirada') {
      handleModalConfirm();

      return false;
    }

    if (formatedAssinatura.status === 'Ativa') {
      setModalInfo({
        title: 'VOCÊ TEM CERTEZA?',
        description: `A renovação de sua assinatura será cancelada, mas você ainda poderá utilizar os recursos contratados até: ${formatedAssinatura.dataVencimento}`,
      });
    } else if (formatedAssinatura.status === 'Suspensa') {
      setModalInfo({
        title: 'A sua assinatura será reativada. Deseja continuar?',
      });
    }

    if (modalRef.current?.toggle) {
      modalRef.current.toggle();
    }
  };

  const cancelarAssinatura = async () => {
    try {
      setFormSubmiting(true);

      await api.get(`/suspenderAssinatura/${usuario.id}`);

      openAlert('Assinatura cancelada com sucesso!');

      refetch();
    } catch (error) {
      const errorMessage = error?.response?.data?.message;

      openAlert(errorMessage ?? 'Erro ao cancelar assinatura!', 'error');
    } finally {
      setFormSubmiting(false);
    }
  };

  const ativarAssinatura = async () => {
    try {
      setFormSubmiting(true);

      await api.get(`/ativarAssinatura/${userId}`);

      openAlert('Assinatura ativada com sucesso!');

      refetch();
    } catch (error) {
      const errorMessage = error?.response?.data?.message;

      openAlert(errorMessage ?? 'Erro ao ativar assinatura!', 'error');
    } finally {
      setFormSubmiting(false);
    }
  };

  const handleModalConfirm = () => {
    if (formatedAssinatura.status === 'Ativa') {
      modalTermoCancelamentoRef.current?.toggle();
    } else if (formatedAssinatura.status === 'Suspensa') {
      ativarAssinatura();
    } else {
      setShowContratarAssinatura(true);
    }
  };

  const concluirAssinatura = async () => {
    const uuid =
      typeCompany === '1'
        ? 'd490cb59-db44-4a6b-87b9-07a285d79236'
        : '0f36236d-e234-4656-a6e8-6ea2ac5dcf8d';

    const instance = instanceAxios();

    if (hasCompany) {
      history.push({
        pathname: '/signature',
        state: {
          openingMEICompany: typeCompany === '1',
          user: usuario,
          portal: true,
        },
      });
    } else {
      await instance
        .get(`/listarServicos/${uuid}`)
        .then(async (res) => {
          if (res.data?.length > 0) {
            const itemFilter = res.data[0];

            setLoading(false);

            const result = await instance.get(
              `/buscarPlanoAssinatura/${typeCompany}`
            );

            history.push({
              pathname: '/open',
              state: {
                item: itemFilter,
                signaturePlan: result.data[0],
                portal: true,
                user: {
                  ...usuario,
                  idPlano: typeCompany,
                },
              },
            });
          } else {
            throw new Error('Lista de serviços vazia');
          }
        })
        .catch((err) => {
          setLoading(false);
          setMessage({
            text: `ERROR: ${requestMessageError(err)}`,
            icon: 'remove_circle_outline',
            color: 'red',
          });
        });
    }
  };

  const userCanContratarAssinatura =
    usuario.existsProcessOpenCompany === false &&
    data === null &&
    isLoading === false &&
    usuario.companyType;

  return showContratarAssinatura || userCanContratarAssinatura ? (
    <ContratarAssinatura
      planoId={formatedAssinatura?.idPlanoAssinatura ?? usuario.companyType}
    />
  ) : (
    <Container isLoading={isLoading} maxwidth={600}>
      <Collapse in={alert.open}>
        <Alert severity={alert.severity} onClick={closeAlert}>
          {alert.message}
        </Alert>
      </Collapse>
      {data === null &&
      usuario.existsProcessOpenCompany &&
      isLoading === false ? (
        <>
          <Title>Olá{usuario?.nome && `, ${usuario?.nome}`}</Title>

          <Typography>
            A sua assinatura será ativada após a conclusão do processo de
            abertura da sua empresa.
          </Typography>
          <br />
          <Typography>
            Obrigado, <br />
            Equipe de Assessoria Fiscal
          </Typography>
        </>
      ) : formatedAssinatura === null ? (
        <>
          <Title>Olá{usuario?.nome && `, ${usuario?.nome}`}</Title>

          <Typography style={{ marginBottom: '1.5rem' }}>
            É preciso contratar o processo de abertura ou inserir os dados da
            sua empresa, para ter acesso a assinatura.
          </Typography>

          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              concluirAssinatura();
            }}
          >
            Concluir assinatura
          </Button>
        </>
      ) : null}
      {formatedAssinatura && (
        <AssinaturaInfo
          status={formatedAssinatura.status}
          valor={formatedAssinatura.valorAssinatura}
          dataContratacao={formatedAssinatura.dataContratacao}
          onAssinaturaClick={handleAssinaturaPress}
          isSubmiting={formSubmiting}
        />
      )}
      <SuperModal
        ref={modalRef}
        title={modalInfo.title}
        description={modalInfo.description}
        onConfirm={handleModalConfirm}
      />
      <SuperModal
        ref={modalTermoCancelamentoRef}
        title={'SUSPENSÃO / CANCELAMENTO DA ASSINATURA DOS SERVIÇOS '}
        description={<TermoCancelmento />}
        onConfirm={cancelarAssinatura}
        styles={{
          width: '100%',
          maxWidth: 800,
        }}
      />
      {hasContratarAssinaturaSuccess && <AssinaturaContratadaModal />}
    </Container>
  );
}

export default AssinaturaUsuario;
